import type { ReactNode } from "react";
import { cx } from "./cx";
import s from "./filterchips.module.css";

export interface ChipOption<T extends string> {
  value: T;
  label: string;
  count?: number;
}

export interface FilterChipsProps<T extends string> {
  options: ReadonlyArray<ChipOption<T>>;
  value: T;
  onChange: (value: T) => void;
  label: string;
  /** Rendered before the chips, e.g. the number selector, then a hairline. */
  leading?: ReactNode;
  className?: string;
}

/** A single-select row of pill buttons (`aria-pressed`) that scrolls sideways. */
export function FilterChips<T extends string>({ options, value, onChange, label, leading, className }: FilterChipsProps<T>) {
  return (
    <div className={cx(s.fch, className)} role="group" aria-label={label}>
      {leading ? <>{leading}<span className={s.sep} aria-hidden="true" /></> : null}
      {options.map((o) => (
        <button key={o.value} type="button" aria-pressed={o.value === value} onClick={() => onChange(o.value)}>
          {o.label}{o.count ? " " : null}{o.count ? <span className={s.n}>{o.count}</span> : null}
        </button>
      ))}
    </div>
  );
}
